'use client'

import { useCallback } from 'react'

import { useBottomSheet } from '../bottom-sheet'
import { SetIdentificationContent } from './components/set-identification-container'
import { SetIdentificationProps } from './set-identification.types'

export const useSetIdentification = () => {
  const { openInfo, onClose } = useBottomSheet()

  const openSetIdentification = useCallback(
    ({
      title,
      subtitle,
      handleSubmit,
      isLoading = false,
      closeAfterFinish = true,
    }: SetIdentificationProps) => {
      openInfo({
        header: {
          content: title,
          label: subtitle,
        },
        canClose: true,
        isLoading,
        isLoadingContent: isLoading,
        children: (
          <SetIdentificationContent
            closeAfterFinish={closeAfterFinish}
            handleSubmit={handleSubmit}
            onClose={onClose}
          />
        ),
      })
    },
    [openInfo, onClose]
  )

  return { openSetIdentification, onClose }
}
